// src/components/UserMeet/User-Meet-Private/EndBreakoutModal.jsx
import React from "react";
import { X, StopCircle, AlertTriangle } from "lucide-react";

export default function EndBreakoutModal({ open, onClose, onConfirm, ending }) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 bg-black/75 backdrop-blur-sm flex items-center justify-center z-[10000] p-5 animate-fadeIn"
      onClick={onClose}
    >
      <div
        className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl shadow-2xl max-w-md w-full border border-red-500/10 animate-slideUp"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="px-6 py-5 border-b border-white/10 flex items-start justify-between gap-4">
          <div className="flex items-start gap-4 flex-1">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-red-500/15 to-rose-500/15 border border-red-500/30 flex items-center justify-center flex-shrink-0">
              <StopCircle className="w-6 h-6 text-red-400" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-white mb-1">
                End Breakout Room
              </h2>
              <p className="text-sm text-white/60">
                This action cannot be undone
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            disabled={ending}
            className="w-8 h-8 rounded-lg bg-white/5 border border-white/10 text-white/70 hover:bg-red-500/15 hover:border-red-500/30 hover:text-red-400 transition-all flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0"
          >
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-5">
          {/* Warning Card */}
          <div className="flex gap-3 p-4 bg-red-500/8 border border-red-500/20 rounded-xl mb-5">
            <AlertTriangle
              size={20}
              className="text-red-400 flex-shrink-0 mt-0.5"
            />
            <div>
              <p className="text-sm font-semibold text-red-400 mb-1">
                Are you sure you want to end this breakout?
              </p>
              <p className="text-sm text-white/60 leading-relaxed">
                Ending the breakout room will remove{" "}
                <span className="text-white font-semibold">
                  all participants
                </span>{" "}
                and return everyone to the main meeting immediately.
              </p>
            </div>
          </div>

          {/* What happens list */}
          <div className="space-y-2.5">
            <p className="text-xs font-bold text-white/40 uppercase tracking-wide">
              What will happen
            </p>
            {[
              "All participants will be returned to the main meeting",
              "The private breakout room will be permanently closed",
              "Any ongoing conversations will be ended",
            ].map((item) => (
              <div key={item} className="flex items-start gap-2.5">
                <div className="w-1.5 h-1.5 rounded-full bg-red-400/70 mt-1.5 flex-shrink-0" />
                <p className="text-sm text-white/60">{item}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-5 border-t border-white/10 flex items-center gap-3">
          <button
            onClick={onClose}
            disabled={ending}
            type="button"
            className="flex-1 px-5 py-2.5 rounded-xl bg-white/5 border border-white/15 text-white/80 font-semibold text-sm hover:bg-white/10 hover:border-white/25 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={ending}
            type="button"
            className="flex-1 px-5 py-2.5 rounded-xl bg-gradient-to-r from-red-500 to-rose-500 border border-red-500/50 text-white font-semibold text-sm hover:from-rose-500 hover:to-red-600 hover:shadow-lg hover:shadow-red-500/30 hover:-translate-y-0.5 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {ending ? (
              <>
                <div className="w-3.5 h-3.5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                Ending...
              </>
            ) : (
              <>
                <StopCircle size={16} />
                End Breakout
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}